import {RequirementCompound} from "./requirementCompound";
import {ITest} from "./requirement";

export class RequirementOr extends RequirementCompound {
    test(props: ITest): boolean {
        return this.requirements.some(requirement => requirement.test(props));
    }
}